export const DEVICE_TYPE = 1;
